module.exports = __webpack_public_path__ + "img/dshg-01.prt.50da53d2.jpg";